<script lang="ts">
  import { Button, Card, Col, Row } from "sveltestrap"
  import PilTooltip from "./PilTooltip.svelte"
  import { chainId, connected, selectedAccount, web3 } from "svelte-web3"
  import { tokenPrice } from "../stores/store"
  import { getTotalRoundValue, getTotalMetaNftValue, getPairDetail } from "../stores/query"
  import { nFormatter } from "../utils/utils"
  import { COREABI } from "../abis/core"
  import { CONFIG } from "../config"
  import TxModal from "./TxModal.svelte"

  export let tab: String;

  let roundTotalValue = 0;
  let roundYield = 0;
  let roundReward = 0;

  let pairTotalValue = 0;
  let pairYield = 0;
  let pairReward = 0;

  let txHash = '';
  let claimUserRewardDisabled = false;
  let claimUserRewardModalOpen = false;

  const claimUserReward = async () => {
    const pilgrim = new $web3.eth.Contract(COREABI, CONFIG[$chainId].CORE_ADDRESS);
    pilgrim.methods.claimUserReward().send({ from: $selectedAccount })
      .on('transactionHash', hash => {
        console.log(hash);
        txHash = hash;
        claimUserRewardDisabled = true;
        claimUserRewardModalOpen = true;
      })
      .on('receipt', receipt => {
        console.log(receipt);
        roundReward = 0;
        claimUserRewardDisabled = false;
      })
  }

  $: try {
    if ($connected && !$getTotalRoundValue.fetching && $getTotalRoundValue.data !== undefined && $getTotalRoundValue.data.user !== null) {
      let totalRoundCost = 0;
      roundTotalValue = 0;
      for (let row of $getTotalRoundValue.data.user.roundTokenBalances) {
        const roundBalance = Number.parseInt(row.roundTokenBalance) / 1e18;
        const roundValue = roundBalance * Number.parseFloat(row.pair.roundTokenPrice);
        const roundCost = roundBalance * Number.parseFloat(row.averageCost);
        const currentTokenPrice = $tokenPrice[row.pair.baseToken.symbol];
        roundTotalValue += currentTokenPrice * roundValue;
        totalRoundCost += currentTokenPrice * roundCost;
      }
      if (totalRoundCost > 0) {
        roundYield = (roundTotalValue - totalRoundCost) / totalRoundCost * 100;
      }
      const earnedReward = Number.parseFloat($getTotalRoundValue.data.user.earnedReward);
      const claimedReward = Number.parseFloat($getTotalRoundValue.data.user.claimedReward);
      roundReward = earnedReward - claimedReward;
    }
  } catch(e) {
    console.error(e);
  }

  $: try {
    if ($connected && !$getTotalMetaNftValue.fetching && $getTotalMetaNftValue.data !== undefined && $getTotalMetaNftValue.data.user !== null) {
      let totalListingPrice = 0;
      pairTotalValue = 0;
      for (let row of $getTotalMetaNftValue.data.user.pairs) {
        const currentTokenPrice = $tokenPrice[row.baseToken.symbol];
        pairTotalValue += currentTokenPrice * Number.parseFloat(row.nftPrice);
        totalListingPrice += 1e6 * Number.parseFloat(row.pairDayData[0].open) * currentTokenPrice;
        const earnedReward = Number.parseFloat(row.earnedReward);
        const claimedReward = Number.parseFloat(row.claimedReward);
        pairReward += earnedReward - claimedReward;
      }
      if (totalListingPrice > 0)
        pairYield = (pairTotalValue - totalListingPrice) / totalListingPrice * 100;
    }
  } catch(e) {
    console.error(e);
  }
</script>

<Card class="info-card pf-summary">
  <Row>
    <Col class="pf-card-label">
      {#if tab === 'all'}
        Total value
      {:else if tab === 'round'}
        Total round value
      {:else}
        Total metaNFT value
      {/if}
      <PilTooltip tooltipId="pos-total-value">Value of rounds + metaNFT in USDC</PilTooltip>
    </Col>
  </Row>
  <Row>
    <Col class="pf-card-main-value">
      {#if tab === 'all'}
        {nFormatter(roundTotalValue + pairTotalValue, 2)}
      {:else if tab === 'round'}
        {nFormatter(roundTotalValue, 2)}
      {:else}
        {nFormatter(pairTotalValue, 2)}
      {/if}
      <span class="pf-card-main-unit">USD</span>
    </Col>
  </Row>
  <Row>
    <Col class="col-auto pf-card-sub-first">
      <Row>
        <Col class="pf-card-label">
          {#if tab === 'all'}
            Round yield
          {:else}
            Yield
          {/if}
          <img class="icon-small" src="/icons/question.svg" alt="placeholder"/>
        </Col>
      </Row>
      <Row>
        <Col class="pf-card-sub-value">
          {#if tab === 'metanft'}
            {nFormatter(pairYield, 2)}
          {:else}
            {nFormatter(roundYield, 2)}
          {/if}
          <span class="pf-card-sub-unit">%</span>
        </Col>
      </Row>
    </Col>
    <!--{#if tab !== 'all'}-->
    <!--  <Col class="col-auto pf-card-sub-second">-->
    <!--    <Row>-->
    <!--      <Col class="pf-card-label">-->
    <!--        PIL mining APY-->
    <!--        <img class="icon-small" src="/icons/question.svg" alt="placeholder"/>-->
    <!--      </Col>-->
    <!--    </Row>-->
    <!--    <Row>-->
    <!--      <Col class="pf-card-sub-value">-->
    <!--        12.68 <span class="pf-card-sub-unit">%</span>-->
    <!--      </Col>-->
    <!--    </Row>-->
    <!--  </Col>-->
    <!--{/if}-->
    <Col class="col-auto">
      <Row>
        <Col class="pf-card-label">
          Total unclaimed PIL
          <img class="icon-small" src="/icons/question.svg" alt="placeholder"/>
        </Col>
      </Row>
      <Row class="align-items-center">
        <Col class="pf-card-sub-value">
          {#if tab === 'all'}
            {nFormatter(roundReward + pairReward, 2)}
          {:else if tab === 'round'}
            {nFormatter(roundReward, 2)}
          {:else}
            {nFormatter(pairReward, 2)}
          {/if}
          <span class="pf-card-sub-unit">PIL</span>
        </Col>
        <Col class="col-auto">
          {#if tab === 'all' && (roundReward > 0 || pairReward > 0)}
            <div class="pf-claim-desc">
              <img class="icon-small" src="/icons/check-primary.svg" alt="placeholder"/>
              You have outstanding PILs to claim
            </div>
          {:else if tab === 'round' && roundReward > 0}
            <Button class="button-fill pf-claim-button" on:click={claimUserReward} disabled={claimUserRewardDisabled}>
              <img class="icon-small" src="/icons/check-black.svg" alt="placeholder"/>
              Claim collected PIL
            </Button>
            <TxModal msg="Claim transaction initiated" txHash={txHash} isOpen={claimUserRewardModalOpen}/>
          {/if}
        </Col>
      </Row>
    </Col>
  </Row>
</Card>
